import React from "react";
import { motion } from "framer-motion";
import { RevealLine } from "./RevealLine";
import HeroCopyCommand from "./HeroCopyCommand";

/**
 * Kinetic hero — masked line-by-line reveal + subtle parallax badge.
 * Layout is asymmetric: headline spans left, meta rail lives on the right.
 */
export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-28 md:pt-32 pb-12 md:pb-16 px-6 md:px-10 overflow-hidden"
    >
      {/* Faint background grid */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "linear-gradient(var(--w-ink) 1px, transparent 1px), linear-gradient(90deg, var(--w-ink) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
          backgroundPosition: "8px 0",
          maskImage:
            "radial-gradient(ellipse at 50% 30%, black 40%, transparent 75%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at 50% 30%, black 40%, transparent 75%)",
        }}
      />

      <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
        {/* Headline */}
        <div className="md:col-span-8 md:col-start-3">
          <h1
            data-testid="hero-headline"
            className="font-serif text-[15vw] md:text-[10.5vw] lg:text-[9.4vw] leading-[0.92] tracking-[-0.02em] text-ink text-center"
            style={{ letterSpacing: "-0.02em" }}
          >
            <div>
              <RevealLine delay={0.15}>Control what</RevealLine>
            </div>
            <div>
              <RevealLine delay={0.3}>your AI&nbsp;</RevealLine>
              <RevealLine delay={0.42} className="italic text-[hsl(38_92%_55%)]">
                sees.
              </RevealLine>
            </div>
          </h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="mt-8 flex justify-center"
          >
            <p className="max-w-xl text-center text-lg leading-relaxed text-ink-70 md:text-xl">
              One conversation. Any direction.
            </p>

          </motion.div>

          {/* Install command */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.15, duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="mt-8 md:mt-10 flex flex-col items-center"
          >
            <HeroCopyCommand />
          </motion.div>
        </div>

      </div>
    </section>
  );
}
